import React, { useState } from 'react';
import Tilt from 'react-parallax-tilt';

import Backing from './CardBacking';

import './Card.css';
import { prefix } from '@fortawesome/free-solid-svg-icons';

const Card = (props) => {
    const color = props.theme;

    const isMobile = window.innerWidth < 600;

    let ProductCardClass = 'ProductCard';
    let CardTiltState = false;

    if (isMobile == false) {
        ProductCardClass = 'ProductCard--Animated';
        CardTiltState = true;
    }

    let CardStyle;
    let CropStyle;

    console.log(props);

    CardStyle = 'CardImage';

    if (props.products == 'Greeting Cards') {
        CardStyle = 'CardImage-G';

        if (
            props.ID == 'GB3' ||
            props.ID == 'GA1' ||
            props.ID == 'GX1' ||
            props.ID == 'GX2' ||
            props.ID == 'GX3' ||
            props.ID == 'GX4'
        ) {
            CardStyle = 'CardImage-G-Rotated';
        }
    }

    return (
        <div
            className={ProductCardClass}
            style={{ background: 'hsl(0,0%, 95%)' }}
        >
            <div className='ProductCard__ImageContainer'>
                <Tilt
                    tiltReverse={1}
                    glareColor={'hsla(200, 0%, 0%, 50%)'}
                    glareBorderRadius={props.borderRadius}
                    glarePosition={'left'}
                    className='ProductCard__Tilt'
                    perspective={2000}
                    tiltEnable={CardTiltState}
                >
                    <div
                        className='ImageCrop'
                        style={{
                            borderRadius: props.borderRadius,
                        }}
                    >
                        <img
                            className={CardStyle}
                            style={{
                                borderRadius: props.borderRadius,
                            }}
                            src={props.product.img}
                        />
                    </div>

                    {/* <Backing products={props.products} /> */}
                    <div
                        className='CardID'
                        style={{
                            background: 'hsl(' + color + ', 45%)',
                            borderBottomLeftRadius: props.borderRadius,
                            display: props.ID == 'CB20' ? 'none' : 'auto',
                        }}
                    >
                        {props.ID}
                    </div>
                </Tilt>
            </div>

            <div
                className='CardName'
                style={{
                    color: '#000',
                    display: props.prefix == 'CB' ? 'none' : 'auto',
                }}
            >
                {props.product.name}
            </div>
        </div>
    );
};

export default Card;
